/**
 * Maps inferred country codes to privacy notice addendum tabs.
 * Used on the Privacy Policy page and hooks; detection is heuristic (IP + browser locale).
 */
/** US privacy notice anchor (CCPA/CPRA “Do Not Sell or Share”). */
export const PRIVACY_DO_NOT_SELL_HASH = '#do-not-sell';
/** Cookie policy section on the privacy notice page. */
export const PRIVACY_COOKIES_HASH = '#cookies';
/** EU / EEA / UK / GI plus Canada and UAE — consent-first defaults for optional cookies and analytics. */
export const CONSENT_FIRST_COUNTRY_CODES = new Set([
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'GB',
    'GI',
    'CA',
    'AE',
]);
/** Countries mapped to the UK/EEA GDPR addendum tab (excludes CA/AE which use consent-first but different regimes). */
const UK_EU_GDPR_ADDENDUM_COUNTRIES = new Set([...CONSENT_FIRST_COUNTRY_CODES].filter(c => c !== 'CA' && c !== 'AE'));
export function isConsentFirstCountry(countryCode) {
    if (!countryCode || typeof countryCode !== 'string')
        return false;
    const c = countryCode.trim().toUpperCase();
    return c.length === 2 && CONSENT_FIRST_COUNTRY_CODES.has(c);
}
/** CCPA/CPRA-style “Do Not Sell or Share” notice — we link when geo resolves to the US (best-effort). */
export function shouldShowDoNotSellLinkFromCountry(countryCode) {
    if (!countryCode || typeof countryCode !== 'string')
        return false;
    return countryCode.trim().toUpperCase() === 'US';
}
export function inferAddendumFromCountry(countryCode) {
    if (!countryCode || typeof countryCode !== 'string')
        return null;
    const c = countryCode.trim().toUpperCase();
    if (c.length !== 2)
        return null;
    if (UK_EU_GDPR_ADDENDUM_COUNTRIES.has(c))
        return 'uk_eu_gdpr';
    if (c === 'US')
        return 'us_state';
    if (c === 'ZA')
        return 'popia';
    if (c === 'SA')
        return 'pdpl_saudi';
    return null;
}
/** Hash anchors used for deep linking from signup / consent settings. */
export const PRIVACY_ADDENDUM_HASH = {
    uk_eu_gdpr: '#addendum-uk-eu',
    us_state: '#addendum-us',
    popia: '#addendum-popia',
    pdpl_saudi: '#addendum-pdpl',
};
export function addendumFromHash(hash) {
    const h = hash.trim().toLowerCase();
    if (h === '#addendum-uk-eu' || h === 'addendum-uk-eu')
        return 'uk_eu_gdpr';
    if (h === '#addendum-us' || h === 'addendum-us')
        return 'us_state';
    if (h === '#addendum-popia' || h === 'addendum-popia')
        return 'popia';
    if (h === '#addendum-pdpl' || h === 'addendum-pdpl')
        return 'pdpl_saudi';
    return null;
}
